module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "Office"
  }, [_c('md-whiteframe', {
    staticClass: "shadow shadow-faint"
  }, [_c('div', {
    staticClass: "search search--field"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.query),
      expression: "search.query"
    }],
    staticStyle: {
      "outline": "0"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.translate.pages.absence.index.search
    },
    domProps: {
      "value": (_vm.search.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.searchIndicator))])]), _vm._v(" "), (_vm.addButton) ? _c('md-button', {
    staticClass: "md-icon-button md-raised button",
    nativeOn: {
      "click": function($event) {
        _vm.addAbsence($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _c('md-button', {
    staticClass: "md-icon-button md-raised button-remove",
    nativeOn: {
      "click": function($event) {
        _vm.removeAbsences($event)
      }
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table table--office table-mobile table--abs"
  }, [(_vm.absences.length > 0) ? _c('md-table-card', {
    staticClass: "table--wrap"
  }, [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-by": "name"
    },
    on: {
      "sort": _vm.onSort,
      "select": _vm.onSelect
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "td-sort-name",
    attrs: {
      "md-sort-by": "name"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.fields.office))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "start"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.fields.start))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "end"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.fields.end))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "reason"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.fields.reason))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile"
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.fields.actions))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.absences), function(row, rowIndex) {
    return _c('md-table-row', {
      key: rowIndex,
      attrs: {
        "md-item": row,
        "md-selection": ""
      }
    }, [_c('md-table-cell', {
      staticClass: "name--cell"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.srcImage(row.office.path)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(row.office.name))]), _vm._v(" "), _c('span', {
      staticClass: "subname visible-mobile"
    }, [_vm._v(_vm._s(row.reason))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "double-content"
    }, [_c('span', {
      staticClass: "first-content"
    }, [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.start)))]), _vm._v(" "), _c('span', {
      staticClass: "last-content visible-lsmall"
    }, [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.end)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-lsmall"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatTimeStamp")(row.end)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-mobile"
    }, [_c('span', [_vm._v(_vm._s(row.reason))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "actions"
    }, [_c('md-icon', {
      staticClass: "icon-edit raised",
      nativeOn: {
        "click": function($event) {
          _vm.openDialog('edit', row, rowIndex)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('md-icon', {
      staticClass: "icon-delete raised",
      nativeOn: {
        "click": function($event) {
          _vm.remove(row, rowIndex)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1), _vm._v(" "), _c('md-dialog', {
    ref: "edit",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.edit.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.office.invalid
    },
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.office))]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "office",
      "id": "office"
    },
    model: {
      value: (_vm.currentAbsence.office),
      callback: function($$v) {
        _vm.currentAbsence.office = $$v
      },
      expression: "currentAbsence.office"
    }
  }, _vm._l((_vm.offices), function(office) {
    return _c('md-option', {
      key: office.id,
      attrs: {
        "value": office.id
      }
    }, [_vm._v(_vm._s(office.name))])
  })), _vm._v(" "), (_vm.errors.office.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.office.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.start_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.startDate
    },
    model: {
      value: (_vm.currentAbsence.start_date),
      callback: function($$v) {
        _vm.currentAbsence.start_date = $$v
      },
      expression: "currentAbsence.start_date"
    }
  }), _vm._v(" "), (_vm.errors.start_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.start_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.start_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'start_time')
      }
    },
    model: {
      value: (_vm.currentAbsence.start_time_value),
      callback: function($$v) {
        _vm.currentAbsence.start_time_value = $$v
      },
      expression: "currentAbsence.start_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.start_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.end_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.endDate
    },
    model: {
      value: (_vm.currentAbsence.end_date),
      callback: function($$v) {
        _vm.currentAbsence.end_date = $$v
      },
      expression: "currentAbsence.end_date"
    }
  }), _vm._v(" "), (_vm.errors.end_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.end_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.end_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'end_time')
      }
    },
    model: {
      value: (_vm.currentAbsence.end_time_value),
      callback: function($$v) {
        _vm.currentAbsence.end_time_value = $$v
      },
      expression: "currentAbsence.end_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.end_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary checkbox-list",
    attrs: {
      "md-theme": "green",
      "id": "interval",
      "name": "interval"
    },
    model: {
      value: (_vm.currentAbsence.interval),
      callback: function($$v) {
        _vm.currentAbsence.interval = $$v
      },
      expression: "currentAbsence.interval"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.absence_in_intervals))]), _vm._v(" "), _c('span', {
    staticClass: "color_form_placeholder normal"
  }, [_vm._v("    " + _vm._s(_vm.translate.pages.absence.edit.fields.absence_in_intervals_description))])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.reason.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.absence.edit.fields.reason))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.currentAbsence.reason),
      callback: function($$v) {
        _vm.currentAbsence.reason = $$v
      },
      expression: "currentAbsence.reason"
    }
  }), _vm._v(" "), (_vm.errors.reason.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.reason.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.edit.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "float-r md-primary sm-size md-size btn--blue",
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.edit.save))])], 1)], 1)], 1) : _c('div', [(_vm.search.isQuery) ? _c('h3', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.no_results) + " \""), _c('strong', [_vm._v(_vm._s(_vm.search.query) + "\".")])]) : _c('h3', [(_vm.fetchData) ? _c('span', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.absence.index.no_records))]) : _c('span', [_c('div', {
    staticClass: "sk-rotating-plane"
  })])])])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02b28509"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Absence/Index.vue
// module id = 655
// module chunks = 1